<template>
  <div class="overview-card smooth-shadow">
    <!-- HEADER -->
    <div class="overview-card-header">
      <icon
        type="button"
        @click="$router.push(`/entities/${getEntityId}/lookup`)"
        >arrow_back</icon
      >
      <expand />
      <button class="header-buttons" @click="copyToClipBoard(getLink())">
        <icon size="18">share</icon>Copy Share Link
      </button>
      <!-- <button class="header-buttons">
        <icon size="18">print</icon>Print
      </button> -->
    </div>
    <!-- Contents -->
    <div v-if="isLoading" class="flex-row-align-center pad-30">
      <LoadingBar />
    </div>
    <div v-else-if="!isLoading && overviewData" class="overview-contents">
      <!-- Meta area, type and id of the entity-->
      <div class="entity-meta">
        <icon class="row-icon">device_hub</icon>
        <div class="item">
          <label>Entity Type</label>
          <h2>{{ overviewData.entity_name }}</h2>
        </div>
        <div class="item mar-left-30">
          <label>Entity Id</label>
          <h2>
            {{ getEntityItemId }}
            <span @click="copyToClipBoard(getEntityItemId)">Copy</span>
          </h2>
        </div>
      </div>
      <!-- Stats for the events -->
      <div class="event-stats-area">
        <div class="stats-area">
          <!-- initial and final locations -->
          <div class="row">
            <icon class="row-icon">access_time</icon>
            <div class="flex-expand grid-2">
              <div class="item">
                <label>First Seen</label>
                <h3>{{ formatDate(overviewData.first_seen) }}</h3>
              </div>
              <div class="item">
                <label>Last Seen</label>
                <h3>{{ formatDate(overviewData.last_seen) }}</h3>
              </div>
            </div>
          </div>

          <div class="row mar-top-20">
            <icon class="row-icon">bar_chart</icon>
            <div class="flex-expand grid-3 border-top">
              <div class="item">
                <label>Total Events</label>
                <h3>{{ overviewData.total_events }}</h3>
              </div>
              <div class="item">
                <label>Total Sessions</label>
                <h3>0</h3>
              </div>
              <!-- <div class="item">
                <label>Active Period</label>
                <h3>1 y 2 mos</h3>
              </div>-->
            </div>
          </div>

          <!-- <div class="row mar-top-10">
            <icon class="row-icon">smartphone</icon>
            <div class="flex-expand grid-3 border-top">
              <div class="item">
                <label>Device Brand</label>
                <h3>Samsung</h3>
              </div>
              <div class="item">
                <label>Device Model</label>
                <h3>A700FD</h3>
              </div>
              <div class="item">
                <label>Netword Carrier</label>
                <h3>Jio Infocom</h3>
              </div>
            </div>
          </div>-->
        </div>
        <div class="visualisation-area"></div>
      </div>
    </div>

    <div v-show="!isLoading">
      <EntityDetailsTable />
    </div>

    <div v-if="!isLoading" class="event-summary">
      <EventSummary
        v-if="
          overviewData &&
          overviewData.event_summary &&
          overviewData.event_summary.length > 0
        "
        :col_filter="col_filter"
        :data="overviewData.event_summary"
        :total_events="overviewData.total_events"
        @selectFilter="addToFilters"
        @saveTimeFilters="saveTimeFilters"
      />
    </div>

    <div v-if="!isLoading" class="stream-data">
      <EventStream
        v-if="
          overviewData &&
          overviewData.event_stream &&
          overviewData.event_stream.length > 0
        "
        :events="events"
        :staticEntities="getActiveStaticLayers"
        :isMoreDataAvailable="currentPage < totalPages"
        :isLoading="isEventsLoading"
        @loadMore="loadMoreEvents"
      />
    </div>
  </div>
</template>

<script>
import EventStream from "@/components/entity_overview/views/EventStream";
import EventSummary from "@/components/entity_overview/views/EventSummary";
import EntityDetailsTable from "@/components/entity_overview/views/EntityDetailsTable";
import { mapActions, mapGetters } from "vuex";
import moment from "@/lib/moment";

export default {
  components: {
    EventStream,
    EventSummary,
    EntityDetailsTable,
  },
  data() {
    return {
      isLoading: true,
      currentPage: 1,
      totalPages: null,
      overviewData: null,
      events: [],
      isEventsLoading: false,
      event_col_name: null,
      columns: null,
      col_filter: {},
      time_filters: {},
    };
  },
  computed: {
    ...mapGetters("Entities", ["getEntities"]),
    ...mapGetters("LayerManager", ["getActiveStaticLayers"]),
    getEntityId() {
      return this.$route.params.entity_id;
    },
    getEntityItemId() {
      return this.$route.params.item_id;
    },
  },
  methods: {
    ...mapActions("Entities", ["fetchEntities"]),
    ...mapActions("Lookup", ["fetchEntityOverview"]),
    ...mapActions("LayerManager", ["loadStaticEntity"]),

    copyToClipBoard(value) {
      this.$clipboard(value);
      this.$notify({
        group: "main",
        title: "Copied to clipboard",
        type: "success",
      });
    },
    getLink() {
      return window.location.href;
    },
    addToFilters(value) {
      this.col_filter = {
        colname: this.event_col_name,
        comparison: "=",
        value: value,
      };
      this.loadEvents();
    },
    saveTimeFilters(timeFilters) {
      this.time_filters = {
        window: timeFilters.selectedDate,
        days: timeFilters.selectedDays,
        time_slots: timeFilters.selectedPeaks,
      };
      // console.log(this.time_filters);
      // this.loadEvents();
    },
    formatDate(date) {
      if (date instanceof Date) {
        return moment(date).format("DD/MM/YY h:mm a");
      } else {
        return "No data";
      }
    },
    async loadEvents() {
      this.isEventsLoading = true;
      try {
        this.overviewData = await this.fetchEntityOverview({
          entity_id: this.getEntityId,
          entity_item_id: this.getEntityItemId,
          page_id: this.currentPage,
          columns: this.columns, // For meta data about event
          // filters: [this.col_filter],
          // time_filters: this.time_filters
          // What about sort?
        });
        this.events.push(...this.overviewData.event_stream);
        this.totalPages = this.overviewData.total_pages;
        this.isEventsLoading = false;
      } catch (error) {
        console.error(error);
        this.isEventsLoading = false;
      }
    },
    loadMoreEvents() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadEvents();
      }
    },
  },
  async activated() {
    this.isLoading = true;
    this.events = [];
    this.currentPage = 1;
    this.totalPages = null;
    this.overviewData = null;
    try {
      if (!(this.getEntities && this.getEntities.length > 0)) {
        await this.fetchEntities();
      }
      let currentEntity = this.getEntities.find(
        (entity) => entity.id === this.getEntityId
      );

      this.event_col_name = currentEntity.meta.lookup_view.event_col_name;
      this.columns = currentEntity.meta.lookup_view.columns.map(
        (column) => column.col_name
      );

      await this.loadEvents();
    } catch (error) {
      console.error(error);
      this.$router.go(-1);
    }
    this.isLoading = false;
  },
  mounted() {
    // HELP: I don't think this is useful:
    // this.loadStaticEntity();
  },
};
</script>

<style lang="scss" scoped>
.overview-card {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;
  margin-bottom: 50px;

  .overview-card-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid var(--border-color);
    background: var(--color-secondary);
    padding: 10px;
    border-radius: 5px 5px 0 0;

    .header-buttons {
      display: flex;
      align-items: center;
      background: transparent;
      color: var(--font-color);
      border: 0;
      padding: 10px 15px;
      transition: 0.3s all ease-in-out;
      outline: none;

      &:hover {
        background: var(--color-primary-light);
        color: var(--color-primary);
        border-radius: 5px;
        cursor: pointer;
      }

      &:active {
        opacity: 0.7;
      }

      i {
        margin-right: 10px;
      }
    }
  }

  .overview-contents {
    display: flex;
    flex-direction: column;

    .row-icon {
      padding: 15px;
      //background: var(--border-color);
      border-radius: 50%;
      margin-right: 20px;
    }

    .entity-meta {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 15px 20px;

      .item {
        display: flex;
        flex-direction: column;

        &:first-child {
          margin-right: 30px;
        }

        label {
          margin: 10px 0;
        }

        h2 {
          font-size: 1.7em;
          font-weight: bold;

          span {
            color: var(--color-primary);
            font-size: 1rem;
            font-weight: normal;

            &:hover {
              opacity: 0.7;
              cursor: pointer;
            }
          }
        }
      }
    }

    .event-stats-area {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-top: 10px;
      border-top: 1px solid var(--border-color);

      @include respond-below(md) {
        grid-template-columns: 1fr;
      }

      .row {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .stats-area {
        display: flex;
        flex-direction: column;
        padding: 15px 20px;

        .grid-2 {
          display: grid;
          grid-template-columns: 1fr 1fr;
        }

        .grid-3 {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
        }

        .border-top {
          border-top: 1px solid var(--border-color);
        }

        .item {
          display: flex;
          flex-direction: column;
          margin-right: 30px;

          &:first-child {
          }

          label {
            margin: 10px 0 5px 0;
          }

          h3 {
            //font-size: 1.2em;
            font-weight: bold;
            margin-bottom: 10px;
          }
        }
      }
    }

    .stream-data {
      border-top: 1px solid var(--border-color);
    }
  }
}
</style>
